import type { Dict } from './types';

export const ptBR: Dict = {
  // splash
  'splash.loading': 'Carregando…',
  'splash.subtitle': 'Preparando seu bichinho',
  // erro
  'error.generic.title': 'Algo deu errado',
  'error.generic.body': 'Tente recarregar a página.',
  'error.generic.button': 'Recarregar',
  // save
  'save.fallback': 'Save offline indisponível — usando armazenamento de sessão.',
  'save.session-only': 'Não foi possível salvar. Progresso pode ser perdido ao recarregar.',
  // stages
  'stage.egg': 'Ovo',
  'stage.baby': 'Bebê',
  'stage.teen': 'Adolescente',
  'stage.adult': 'Adulto',
  'stage.elder': 'Idoso',
  'stage.dead': 'Falecido',
  // actions
  'action.feed': 'Alimentar',
  'action.play': 'Brincar',
  'action.clean': 'Limpar',
  'action.discipline': 'Disciplinar',
  'action.heal': 'Curar',
  'action.light': 'Luz',
  'action.minigame': 'Jogos',
  'feedback.refused.feed': 'Ainda nao da pra alimentar',
  'feedback.refused.play': 'Ainda nao da pra brincar',
  'feedback.refused.clean': 'Nao tem o que limpar',
  'feedback.refused.discipline': 'Disciplinar agora nao ajuda',
  'feedback.refused.heal': 'Ainda nao da pra curar',
  'feedback.refused.feed.cooldown': 'Calma, ele acabou de comer',
  'feedback.refused.play.cooldown': 'Ele precisa respirar um pouco',
  'feedback.refused.heal.cooldown': 'Remedio recarregando',
  'feedback.refused.clean.notNeeded': 'A caixinha ja esta limpa',
  'feedback.refused.discipline.notNeeded': 'Ele nao esta em birra',
  'feedback.refused.heal.notNeeded': 'Ele nao esta doente',
  'feedback.refused.tantrum': 'Ele esta fazendo birra',
  'feedback.success.feed': 'Nhac!',
  'feedback.success.play': 'Ele gostou!',
  'feedback.success.clean': 'Tudo limpinho',
  'feedback.success.heal': 'Bem melhor',
  'feedback.success.discipline': 'Birra resolvida',
  'feedback.need.feed': 'Ele esta com fome',
  'feedback.need.play': 'Ele quer atencao',
  'feedback.need.clean': 'Hora de limpar a caixinha',
  'feedback.need.heal': 'Ele ficou doente',
  'food.meal.name': 'Refeição',
  'food.meal.short': '+Fome',
  'food.meal.desc': 'Comida normal: muita fome, pouco peso.',
  'food.snack.name': 'Snack',
  'food.snack.short': '+Feliz',
  'food.snack.desc': 'Guloseima: felicidade alta, mais peso.',
  'food.fruit.name': 'Fruta',
  'food.fruit.short': 'Leve',
  'food.fruit.desc': 'Comida balanceada: fome e felicidade leves.',
  'food.protein.name': 'Proteína',
  'food.protein.short': 'Forte',
  'food.protein.desc': 'Comida pesada: muita fome, mais peso.',
  'toy.ball.name': 'Bola',
  'toy.ball.short': 'Ativo',
  'toy.ball.desc': 'Corre e pula atrás da bola; reduz mais peso.',
  'toy.rope.name': 'Corda',
  'toy.rope.short': 'Treino',
  'toy.rope.desc': 'Brincadeira ativa que também treina disciplina.',
  'toy.plush.name': 'Pelúcia',
  'toy.plush.short': 'Conforto',
  'toy.plush.desc': 'Acalma e oferece bastante felicidade.',
  'toy.puzzle.name': 'Puzzle',
  'toy.puzzle.short': 'Foco',
  'toy.puzzle.desc': 'Estimula curiosidade e disciplina.',
  // status
  'status.dead': 'morreu',
  'status.sleeping': 'dormindo',
  'status.tantrum': 'birra',
  'status.sick': 'doente',
  'behavior.mood.hungry': 'com fome',
  'behavior.mood.lonely': 'quer atencao',
  'behavior.mood.dirty': 'incomodado',
  'behavior.mood.sleepy': 'com sono',
  'behavior.mood.bored': 'entediado',
  'behavior.mood.overfed': 'pesado',
  // tooltips
  'tooltip.feed': 'Alimentar (saciar fome)',
  'tooltip.play': 'Brincar (subir felicidade)',
  'tooltip.clean': 'Limpar cocô',
  'tooltip.discipline': 'Disciplinar apenas quando estiver em birra; fora de hora reduz felicidade.',
  'tooltip.heal': 'Aplicar dose de remédio',
  'tooltip.light': 'Acender/apagar a luz',
  'tooltip.hunger': 'Fome — alimente quando estiver baixo.',
  'tooltip.happiness': 'Felicidade — brinque quando estiver baixo.',
  'tooltip.health': 'Saúde — derivada de fome, felicidade, peso, sujeira e doença.',
  'tooltip.discipline.bar': 'Disciplina — alta deixa a criatura mais paciente.',
  'tooltip.weight': 'Peso — afeta velocidade e aparência.',
  // top bar
  'topbar.locale': 'Trocar idioma',
  'topbar.settings': 'Configurações',
  'topbar.bestiary': 'Bestiário',
  'topbar.breeding': 'Cruzar',
  'topbar.lineage': 'Linhagem',
  'topbar.profile': 'Perfil',
  'topbar.reset': 'Reiniciar (zerar progresso)',
  'careProfile.title': 'Perfil de cuidado',
  'careProfile.currentTraits': 'Traços atuais',
  'careProfile.tendencies': 'Tendências',
  'careProfile.story': 'História de cuidado',
  'careProfile.noTraits': 'Nenhum traço se firmou ainda.',
  'careProfile.close': 'Fechar',
  'careProfile.temperament': 'Temperamento',
  'careProfile.summary.calm': 'Paciente e constante nas pequenas rotinas.',
  'careProfile.summary.needy': 'Valoriza companhia e atenção frequente.',
  'careProfile.summary.playful': 'Encontra diversão em quase toda interação.',
  'careProfile.summary.glutton': 'Tem grande interesse por comida e recompensas.',
  'careProfile.summary.stubborn': 'Tem opiniões fortes e reage com intensidade.',
  'careProfile.summary.fragile': 'É sensível e responde muito ao cuidado recebido.',
  'careProfile.summary.tidy': 'Prefere rotina, limpeza e um ambiente organizado.',
  'careProfile.trait.well-fed': 'Bem alimentado',
  'careProfile.trait.spoiled': 'Mimado',
  'careProfile.trait.playful': 'Brincalhão',
  'careProfile.trait.messy': 'Bagunceiro',
  'careProfile.trait.resilient': 'Resiliente',
  'careProfile.trait.disciplined': 'Disciplinado',
  'careProfile.trait.rebellious': 'Rebelde',
  'careProfile.trait.heavy': 'Robusto',
  'careProfile.trait.frail': 'Frágil',
  'careProfile.trait.athletic': 'Atlético',
  'careProfile.trait.comfort-seeker': 'Apegado ao conforto',
  'careProfile.trait.curious': 'Curioso',
  'careProfile.tendency.discovering': 'Ainda está mostrando suas preferências.',
  'careProfile.tendency.balancedDiet': 'Alimentação equilibrada',
  'careProfile.tendency.sweetTooth': 'Gosto por guloseimas',
  'careProfile.tendency.activePlay': 'Preferência por brincadeiras ativas',
  'careProfile.tendency.comfortPlay': 'Preferência por conforto e companhia',
  'careProfile.tendency.focusPlay': 'Preferência por desafios e foco',
  'careProfile.story.new': 'A história de cuidado está apenas começando.',
  'careProfile.story.nutritious': 'Recebe mais refeições nutritivas que guloseimas.',
  'careProfile.story.treats': 'Recebe mais guloseimas que refeições nutritivas.',
  'careProfile.story.lateCleaning': 'Algumas limpezas aconteceram depois da hora.',
  'careProfile.story.cleanHome': 'O ambiente costuma ser limpo quando necessário.',
  'careProfile.story.goodDiscipline': 'As birras são corrigidas nos momentos certos.',
  'careProfile.story.mistakes': 'Alguns cuidados foram oferecidos na hora errada.',
  'careProfile.story.recovered': 'Já recebeu tratamento e se recuperou de doença.',
  // settings
  'settings.title': 'Configurações',
  'settings.locale': 'Idioma',
  'settings.audio.master': 'Volume principal',
  'settings.audio.sfx': 'Efeitos',
  'settings.audio.ambient': 'Ambiente',
  'settings.audio.music': 'Música',
  'settings.audio.muted': 'Mudo',
  'settings.a11y.fontScale': 'Tamanho de fonte',
  'settings.a11y.reducedMotion': 'Reduzir animações',
  'settings.fastMode': 'Modo rápido (dev)',
  'settings.cloud.enabled': 'Sync na nuvem',
  'settings.close': 'Fechar',
  'settings.reset': 'Reiniciar progresso',
  'settings.reset.confirm': 'Reiniciar apaga sua criatura, NPCs e linhagem. Confirmar?',
  // bestiary
  'bestiary.title': 'Bestiário',
  'bestiary.discovered': '{n} de 63 descobertos',
  'bestiary.unknown': 'Desconhecido — descubra cruzando criaturas.',
  'bestiary.group.singular': 'tipo',
  'bestiary.group.plural': 'tipos',
  'bestiary.close': 'Fechar',
  // breeding
  'breeding.title': 'Cruzamento',
  'breeding.canBreed': '{name} está pronto pra cruzar.',
  'breeding.noPartners': 'Nenhum parceiro na família disponível — {name} vai cruzar com um estranho selvagem.',
  'breeding.choosePartner': 'Escolha um parceiro da família de {name}:',
  'breeding.partnerRandom': 'Estranho selvagem',
  'breeding.cannotBreed': '{name} ainda não está pronto. Apenas adultos e idosos podem cruzar.',
  'breeding.success': 'Filho gerado! Pais aposentados como NPCs.',
  'breeding.inheritance.title': 'Herança de {name}',
  'breeding.inheritance.parents': 'Filho de {a} e {b}',
  'breeding.inheritance.close': 'Continuar com o filhote',
  'breeding.inheritance.origin.parent-a': 'Veio de {a}',
  'breeding.inheritance.origin.parent-b': 'Veio de {b}',
  'breeding.inheritance.origin.both': 'Mistura dos dois',
  'breeding.inheritance.origin.variation': 'Variação nova',
  'breeding.inheritance.locus.body': 'Corpo',
  'breeding.inheritance.locus.ears': 'Orelhas',
  'breeding.inheritance.locus.horns': 'Chifres',
  'breeding.inheritance.locus.tail': 'Cauda',
  'breeding.inheritance.locus.markings': 'Marcas',
  'breeding.inheritance.locus.eggPattern': 'Ovo',
  'breeding.inheritance.locus.paletteHue': 'Cores',
  'breeding.inheritance.locus.primaryTypes': 'Elementos',
  'breeding.inheritance.locus.inheritedTraits': 'Traços herdados',
  'breeding.failure': 'Não foi possível: {reason}.',
  'breeding.confirm': 'Cruzar',
  'breeding.cancel': 'Cancelar',
  // lineage
  'lineage.title': 'Linhagem',
  'lineage.activeLabel': 'Ativo',
  'lineage.ancestors': 'Ancestrais',
  'lineage.treeLabel': 'Árvore genealógica do pet ativo',
  'lineage.role.active': 'Pet atual',
  'lineage.role.parent': 'Pai/mãe',
  'lineage.role.grandparent': 'Avô/avó',
  'lineage.npcsAlive': 'NPCs vivos ({n})',
  'lineage.family': 'familiar',
  'lineage.careLegacy': 'cuidado {score}',
  'lineage.memorials': 'Memoriais ({n})',
  'lineage.cause.alive': 'vivo',
  'lineage.cause.old-age': 'velhice',
  'lineage.cause.neglect': 'negligência',
  'lineage.cause.expedition': 'expedição',
  'lineage.totalRegistered': '{n} criaturas registradas',
  'lineage.empty': 'Sua linhagem ainda está vazia. Cruze para começar.',
  'lineage.close': 'Fechar',
  // memorial
  'memorial.title': '{name} se foi',
  'memorial.cause': 'Causa: {cause}.',
  'memorial.newLife': 'Nova geração',
  // evolution
  'evolution.tier.bom': '{name} cresceu forte e saudável!',
  'evolution.tier.medio': '{name} chegou à fase adulta.',
  'evolution.tier.ruim': '{name} cresceu maltratado...',
  'evolution.tier.secreto': '{name} revelou uma forma rara!',
  // minigame
  'minigame.title': 'Mini-jogos',
  'minigame.cooldown': 'Aguarde {time} para jogar novamente.',
  'minigame.guess': 'Adivinhe o lado',
  'minigame.guess.instruction': 'Em qual mão está a guloseima?',
  'minigame.guess.win': 'Acertou!',
  'minigame.guess.lose': 'Errou.',
  'minigame.rps': 'Pedra, Papel, Tesoura',
  'minigame.rps.win': 'Você venceu!',
  'minigame.rps.lose': 'Você perdeu.',
  'minigame.rps.draw': 'Empate.',
  'minigame.memory': 'Memória',
  'minigame.memory.complete': 'Completou!',
  'minigame.close': 'Fechar',
  'minigame.reward': '+{n} felicidade',
  // alchemy types
  'type.Fire': 'Fogo',
  'type.Water': 'Água',
  'type.Earth': 'Terra',
  'type.Air': 'Ar',
  'type.Life': 'Vida',
  'type.Shadow': 'Sombra',
  // biomes
  'biome.meadow': 'Pradaria',
  'biome.forest': 'Floresta',
  'biome.cave': 'Caverna',
  'biome.coast': 'Costa',
  // world
  'world.title': 'Mundo',
  'world.exitToHouse': 'Voltar pra casa',
  'world.goToWorld': 'Sair pra explorar',
  'world.vitality': 'Vitalidade',
  'world.dayPhase.day': 'Dia',
  'world.dayPhase.night': 'Noite',
  'world.collected': 'Pegou {item}!',
  'world.exposure.warning': 'Exposição alta — vitalidade caindo rápido!',
  'world.teleportedHome': 'Vitalidade zerou! Voltou pra casa.',
  'world.cannotEnter.egg': 'Espere o ovo eclodir.',
  'world.cannotEnter.dead': 'A criatura faleceu.',
  'world.cannotEnter.lowVitality': 'Vitalidade muito baixa — descanse em casa.',
  // inventory
  'inventory.title': 'Inventário',
  'inventory.empty': 'Vazio. Explore o mundo para coletar items.',
  'item.berry': 'Frutinha',
  'item.shell': 'Concha',
  'item.crystal': 'Cristal',
  'item.flower': 'Flor',
  // expedition
  'expedition.title': 'Expedição',
  'expedition.start': '⚔️ Iniciar expedição',
  'expedition.confirm.title': 'Iniciar expedição?',
  'expedition.confirm.body': 'A região vai virar perigosa. Inimigos aparecerão. Você pode ganhar mutações roguelite ao matá-los.',
  'expedition.confirm.warning': 'Cuidado: se desmaiar, perde happiness. Se já estiver doente ou idoso, pode morrer permanentemente.',
  'expedition.confirm.proceed': 'Vai com tudo',
  'expedition.confirm.cancel': 'Agora não',
  'expedition.briefing.risk': 'Afinidade',
  'expedition.briefing.risk.favorable': 'favorável',
  'expedition.briefing.risk.neutral': 'neutra',
  'expedition.briefing.risk.hostile': 'hostil',
  'expedition.briefing.enemies': 'Inimigos',
  'expedition.briefing.resources': 'Recursos',
  'expedition.cannotStart.notReady': 'Precisa ser adulto/idoso, não doente, com vitalidade ≥ 30.',
  'expedition.extract': 'Extrair',
  'expedition.extract.confirm': 'Voltar para o mundo? Mutações raras/épicas ficam.',
  'expedition.outcome.extracted': 'Extraiu com sucesso!',
  'expedition.outcome.fainted': 'Desmaiou…',
  'expedition.outcome.died': 'A criatura faleceu na expedição.',
  'expedition.summary.title': 'Resultado',
  'expedition.summary.kills': 'Inimigos derrotados: {n}',
  'expedition.summary.xp': 'XP ganho: {n}',
  'expedition.summary.mutations': 'Mutações:',
  'expedition.summary.close': 'Fechar',
  // mutation pick
  'mutation.pick.title': 'Escolha uma mutação',
  'mutation.pick.body': 'Você sente sua forma mudar.',
  'mutation.tough.name': 'Resistente',          'mutation.tough.desc': '+20 HP máximo',
  'mutation.sharp.name': 'Afiado',              'mutation.sharp.desc': '+5 dano',
  'mutation.swift.name': 'Veloz',               'mutation.swift.desc': '+20 velocidade',
  'mutation.quickHands.name': 'Mãos rápidas',   'mutation.quickHands.desc': '+25% velocidade de ataque',
  'mutation.lucky.name': 'Sortudo',             'mutation.lucky.desc': '+10% chance de crítico',
  'mutation.regen.name': 'Regeneração',         'mutation.regen.desc': '+1 HP/seg',
  'mutation.thornedHide.name': 'Pele de espinhos', 'mutation.thornedHide.desc': 'Reflete 30% do dano recebido',
  'mutation.shield.name': 'Escudo',             'mutation.shield.desc': 'Sem hit por 5s = absorve +20%',
  'mutation.burnTouch.name': 'Toque flamejante', 'mutation.burnTouch.desc': 'Hits aplicam queimadura por 4s',
  'mutation.iceTouch.name': 'Toque gelado',     'mutation.iceTouch.desc': 'Hits desaceleram inimigo 2s',
  'mutation.lifesteal.name': 'Roubavida',       'mutation.lifesteal.desc': '+20% lifesteal',
  'mutation.doubleStrike.name': 'Golpe duplo',  'mutation.doubleStrike.desc': '25% chance de hit duplo',
  'mutation.fortress.name': 'Fortaleza',        'mutation.fortress.desc': '+50 HP, -20 velocidade',
  'mutation.glassCannon.name': 'Canhão de vidro', 'mutation.glassCannon.desc': '+15 dano, -30 HP',
  'mutation.bloodlust.name': 'Sede de sangue',  'mutation.bloodlust.desc': 'Após kill: +30% dano por 5s',
  'mutation.phoenix.name': 'Fênix',             'mutation.phoenix.desc': 'Ressurge 1× com 30% HP',
  'mutation.overload.name': 'Sobrecarga',       'mutation.overload.desc': 'Skill 50% cooldown, -5 HP por uso',
  'mutation.aether.name': 'Éter',               'mutation.aether.desc': 'Ataques aplicam queimadura E gelo',
  // combat HUD
  'combat.skill': 'Especial',
  'combat.skill.aria': 'Habilidade elemental',
  'combat.attack': 'Atacar',
  'combat.attack.aria': 'Atacar',
  'combat.dodge.aria': 'Esquivar',
  'combat.ready': 'pronta',
  'combat.controls': 'Espaço/J/X atacar · Shift/L esquivar · Q/K habilidade',
  'combat.hp': 'HP',
  'combat.kills': 'Kills',
  // enemies
  'enemy.meadow-bunbun.name': 'Coelhinho',
  'enemy.meadow-bee.name': 'Abelhinha',
  'enemy.meadow-bigboar.name': 'Javali',
  'enemy.forest-wolfpup.name': 'Lobinho',
  'enemy.forest-spider.name': 'Aranha',
  'enemy.forest-darkspit.name': 'Darkspit',
  'enemy.cave-bat.name': 'Morcego',
  'enemy.cave-rockling.name': 'Pedrinha',
  'enemy.cave-crystalfly.name': 'Mosca-Cristal',
  'enemy.coast-crabling.name': 'Caranguejinho',
  'enemy.coast-jelly.name': 'Águaviva',
  'enemy.coast-shellbeast.name': 'Concha-Besta',
  // U6 — afk + memorial + tree + bestiary enemies
  'afk.dispatch.title': 'Despachar NPC',
  'afk.dispatch.npc': 'NPC',
  'afk.dispatch.biome': 'Bioma',
  'afk.dispatch.duration': 'Duração',
  'afk.dispatch.short': '1 hora',
  'afk.dispatch.medium': '4 horas',
  'afk.dispatch.long': '12 horas',
  'afk.dispatch.start': 'Despachar',
  'afk.dispatch.cancel': 'Cancelar',
  'afk.claim.title': 'Recompensas prontas!',
  'afk.claim.body': 'Seus NPCs voltaram com itens.',
  'afk.claim.confirm': 'Reclamar tudo',
  'afk.status.active': 'Em andamento',
  'afk.status.claimable': 'Pronto',
  'memorial.npc.title': 'Memorial',
  'memorial.npc.died': 'Faleceu',
  'memorial.npc.cause': 'Causa',
  'tree.stage.sapling': 'Mudinha',
  'tree.stage.small': 'Pequena',
  'tree.stage.adult': 'Adulta',
  'tree.stage.ancient': 'Anciã',
  'bestiary.enemies.title': 'Inimigos',
  'bestiary.enemies.kills': 'Kills: {n}',
  'bestiary.enemies.unknown': '???',
  'bestiary.fauna.title': 'Fauna',
  'bestiary.wild.title': 'Populações selvagens',
  'bestiary.wild.dominant': 'Dominante',
  'bestiary.wild.encounters': '{n} encontros',
  'bestiary.empty': 'Nenhum registro ainda.',
  'bestiary.tab.types': 'Tipos',
  'bestiary.tab.enemies': 'Inimigos',
  // U8 Cloud
  'cloud.title': 'Save na Nuvem',
  'cloud.enable': 'Habilitar sync com a nuvem',
  'cloud.unavailable': 'Cloud indisponível neste build (env não configurada).',
  'cloud.email.placeholder': 'seu@email.com',
  'cloud.magicLink.send': 'Enviar link de login',
  'cloud.magicLink.sent': 'Link enviado! Verifique seu email.',
  'cloud.loggedAs': 'Logado como',
  'cloud.status': 'Status',
  'cloud.status.idle': 'Aguardando',
  'cloud.status.syncing': 'Sincronizando…',
  'cloud.status.synced': 'Sincronizado',
  'cloud.status.error': 'Erro',
  'cloud.status.disabled': 'Indisponível',
  'cloud.lastSync': 'Última sincronização',
  'cloud.syncNow': 'Sincronizar agora',
  'cloud.signOut': 'Deslogar',
  'cloud.signedOut': 'Deslogado.',
  'cloud.synced': 'Save sincronizado!',
  'cloud.error': 'Erro',
  // U9 onboarding & a11y
  'onboarding.title': 'Bem-vindo ao Himotchi!',
  'onboarding.s1': 'Cuide do seu bichinho! Use os botões na base da tela para alimentar, brincar e limpar.',
  'onboarding.s2': 'Quando crescer, ele pode sair pra explorar o mundo. Cuidado com o ambiente — a vitalidade decai!',
  'onboarding.s3': 'Em expedição, derrote inimigos pra ganhar mutações. Quando virar adulto, cruze com outras criaturas pra criar a próxima geração!',
  'onboarding.next': 'Próximo',
  'onboarding.done': 'Bora!',
  'onboarding.skip': 'Pular',
  'a11y.colorblind': 'Modo daltônico',
  'a11y.colorblind.off': 'Desligado',
  'a11y.colorblind.deutero': 'Deuteranopia',
};
